import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import PowerGenerationMaintenanceList from './PowerGenerationMaintenanceList';
import { icon } from 'leaflet';

//redux

const PowerGenerationMaintenance = () => {
	const { id } = useParams();
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
		{ to: '#', label: 'Mantención', icon: 'icon-wrench' },
	];


	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Actividades de Mantención' links={breadcrumbLinks} icon={'icon-hand-coins'} />
					<PowerGenerationMaintenanceList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PowerGenerationMaintenance;
